import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

import _ from 'lodash';
import { createGmakerTemplate, updateGmakerTemplate } from '@/api/gmaker/template.js';
import Uploader from '@/components/Uploader/index.vue';

export default {
  components: {
    Uploader: Uploader
  },

  props: {
    action: {
      type: String,
      default: 'create'
    },

    isProxyTemplate: {
      type: Boolean,
      default: false
    },
    editable: {
      type: Array
    },

    templateInfo: {
      type: Object,
      default: function _default() {}
    },

    loading: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      isShowCheckBox: false,
      configureProp: {
        multiple: true,
        emitPath: false
      },
      formValue: {
        src_template_id: '',
        id: '',
        name: '',
        name_en: '',
        description: '',
        description_en: '',
        estimate_time: 15,
        industry_categories: [],
        difficulty_level: '',
        play_methods: [],
        dimension_type: 2,
        thumbnail: '',
        thumbnail_l: '',
        enable_gameconfig: 1,
        enable_playunit: 2,
        enable_rigid_body: 2,
        enable_wxgame: 2,
        is_allow_ps: this.templateInfo.source && this.templateInfo.source === 'ps' ? 1 : 2
      },
      commonConfig: null
    };
  },


  computed: {
    submitButton: function submitButton() {
      return {
        text: this.action === 'create' ? '立即创建' : '确定',
        type: 'primary'
      };
    },
    defaultPlayProps: function defaultPlayProps() {
      return {
        children: 'child',
        emitPath: false,
        label: 'name',
        value: 'id',
        id: 'id',
        multiple: true
      };
    },
    industryCategoryList: function industryCategoryList() {
      if (!this.commonConfig) return [];
      return (this.commonConfig.industry_categories || []).map(function (item) {
        return {
          value: item.id,
          label: item.name,
          id: item.id
        };
      });
    },
    difficultyLevelList: function difficultyLevelList() {
      if (!this.commonConfig) return [];
      return (this.commonConfig.difficulty_levels || []).map(function (item) {
        return {
          value: item.id,
          label: item.name,
          id: item.id
        };
      });
    },
    playMethodCategoryList: function playMethodCategoryList() {
      if (!this.commonConfig) return [];
      return this.commonConfig.play_methods;
    },
    modelTypeList: function modelTypeList() {
      if (!this.commonConfig) return [];
      return (this.commonConfig.dimension_types || []).map(function (item) {
        return {
          value: item.id,
          label: item.name
        };
      });
    },
    formRules: function formRules() {
      var templateNameValidator = function templateNameValidator(rule, value, callback) {
        if (value.length <= 50) {
          callback();
        } else {
          callback(new Error('模板名称不能超过 50 个字符'));
        }
      };
      var templateDescValidator = function templateDescValidator(rule, value, callback) {
        if (value.length <= 500) {
          callback();
        } else {
          callback(new Error('模板描述不能超过 500 个字符'));
        }
      };

      return {
        name: [{
          required: true,
          trigger: 'blur',
          message: '模板名字不能为空'
        }, {
          validator: templateNameValidator,
          trigger: 'blur'
        }],
        name_en: [{
          required: true,
          trigger: 'blur',
          message: '模板名字不能为空'
        }, {
          validator: templateNameValidator,
          trigger: 'blur'
        }],
        description: [{
          validator: templateDescValidator,
          trigger: 'blur'
        }],
        description_en: [{
          validator: templateDescValidator,
          trigger: 'blur'
        }],
        play_methods: [{
          required: true,
          trigger: 'change',
          message: '模板玩法不能为空'
        }],
        industry_categories: [{
          required: true,
          trigger: 'change',
          message: '行业类型不能为空'
        }],
        difficulty_level: [{
          required: true,
          trigger: 'change',
          message: '难度等级不能为空'
        }],
        dimension_type: [{
          required: true,
          trigger: 'change',
          message: '模板类型不能为空'
        }],
        estimate_time: [{
          required: true,
          trigger: 'change',
          message: '预估时间不能为空'
        }]
      };
    }
  },

  watch: {
    templateInfo: {
      handler: function handler(val) {
        console.log('val', val);
        this.formValue = _extends({}, this.formValue, val);
      },

      deep: true
    }
  },

  mounted: function mounted() {
    this.getConfigureList();
    this.formValue = _extends({}, this.formValue, this.templateInfo);
    this.form = this.$refs.form;
  },


  methods: {
    onSubmit: function onSubmit() {
      var _this = this;

      var utils = {
        create: function () {
          var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
            var postData, res, templateId;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    postData = _extends({}, params);

                    if (_this.formValue.source === 'demand') {
                      postData.demand_id = _this.formValue.src_demand_id;
                      postData.source = _this.formValue.source;
                    } else {
                      postData.src_template_id = _this.formValue.src_template_id;
                    }
                    // 是否为代制作模板， 1：是
                    if (_this.isProxyTemplate) {
                      postData.is_spend_share = 1;
                    }
                    _context.next = 5;
                    return createGmakerTemplate(postData);

                  case 5:
                    res = _context.sent;
                    templateId = _.get(res, 'data.data.id');

                    _this.$emit('create-success', { templateId: templateId });

                  case 8:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, _this);
          }));

          return function create(_x) {
            return _ref.apply(this, arguments);
          };
        }(),

        update: function () {
          var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(params) {
            var res, templateId;
            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    _context2.next = 2;
                    return updateGmakerTemplate(_extends({}, params, {
                      thumbnail: _this.formValue.thumbnail,
                      thumbnail_l: _this.formValue.thumbnail_l,
                      id: _this.formValue.id
                    }));

                  case 2:
                    res = _context2.sent;
                    templateId = _.get(res, 'data.data.id');

                    _this.$emit('update-success', { templateId: templateId });

                  case 5:
                  case 'end':
                    return _context2.stop();
                }
              }
            }, _callee2, _this);
          }));

          return function update(_x2) {
            return _ref2.apply(this, arguments);
          };
        }()
      };

      this.$refs.form.validate(function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(valid) {
          var params;
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  if (!valid) {
                    _context3.next = 14;
                    break;
                  }

                  _context3.prev = 1;
                  params = _extends({}, _.pick(_this.formValue, ['name', 'name_en', 'description', 'description_en', 'industry_categories', 'play_methods', 'estimate_time', 'dimension_type']), {
                    difficulty_level: _this.formValue.difficulty_level === '' ? null : _this.formValue.difficulty_level,
                    source: _this.templateInfo.source || 'dm',
                    industry_categories: _this.formValue.industry_categories.join(','),
                    play_methods: _this.formValue.play_methods.join(','),
                    enable_gameconfig: Number(_this.formValue.enable_gameconfig),
                    enable_playunit: Number(_this.formValue.enable_playunit),
                    enable_rigid_body: Number(_this.formValue.enable_rigid_body),
                    enable_ps_actions: Number(_this.formValue.enable_ps_actions),
                    enable_wxgame: Number(_this.formValue.enable_wxgame),
                    is_allow_ps: Number(_this.formValue.is_allow_ps)
                  });

                  _this.$emit('update:loading', true);
                  _context3.next = 6;
                  return utils[_this.action](params);

                case 6:
                  _this.$emit('update:loading', false);
                  _context3.next = 14;
                  break;

                case 9:
                  _context3.prev = 9;
                  _context3.t0 = _context3['catch'](1);

                  console.error(_context3.t0);
                  _this.$emit('update:loading', false);
                  _this.$emit('create-fail');

                case 14:
                case 'end':
                  return _context3.stop();
              }
            }
          }, _callee3, _this, [[1, 9]]);
        }));

        return function (_x3) {
          return _ref3.apply(this, arguments);
        };
      }());
    },
    onUploadSuccess: function onUploadSuccess(res, file) {
      if (res.code === 0) {
        this.formValue.thumbnail = _.get(res, 'data.url');
      } else {
        this.$message.error(res.msg || '上传失败');
      }
    },
    onUploadlandsSuccess: function onUploadlandsSuccess(res, file) {
      if (res.code === 0) {
        this.formValue.thumbnail_l = _.get(res, 'data.url');
      } else {
        this.$message.error(res.msg || '上传失败');
      }
    },
    cancel: function cancel() {
      this.$emit('cancel');
    },
    getConfigureList: function getConfigureList() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this2.$store.dispatch('config/getGmakerConfig');

              case 2:
                _this2.commonConfig = _context4.sent;

              case 3:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this2);
      }))();
    },
    disabledForm: function disabledForm(name) {
      if (this.editable && this.editable.length) {
        return this.editable.indexOf(name) !== -1;
      }
      return true;
    }
  }
};